import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { NgFor } from '@angular/common';
import { PREFILL_NOTICE_COPY } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

/** "Review organization settings" or "Continue to verification"; null is Cancel, the X or Escape. */
export type PrefillNoticeAnswer = 'continue' | 'review-settings';

export interface PrefillNoticeDialogInput {
    /** Field names from PREFILL_FIELD_LABELS, never stored organization data. */
    labels: string[];
}

/**
 * SD-9498: the saved details Stripe will not accept, shown before verification starts. Asked through
 * `PrefillNoticeDialogStateService`; `PrefillNoticeService` decides whether there is anything to say.
 */
@Component({
    selector: 'app-prefill-notice-dialog',
    standalone: true,
    imports: [NgFor],
    templateUrl: './prefill-notice-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PrefillNoticeDialogComponent {
    @Input() open = false;
    @Input() labels: string[] = [];
    @Output() readonly closed = new EventEmitter<PrefillNoticeAnswer | null>();

    readonly copy = PREFILL_NOTICE_COPY;

    trackByLabel(_index: number, label: string): string {
        return label;
    }
}
